import React, { useState } from "react";
import {
  Card,
  Box,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  IconButton,
  FormLabel,
} from "@mui/material";
import Iconify from "../iconify";

export default function EditTextSettings(props) {
  return (
    <Card sx={{ padding: 4 }}>
      {props.loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={1}>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <TextField
              id={`title${props.lang}`}
              label="Title"
              fullWidth
              value={props.state[`title${props.lang}`]}
              variant="standard"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>
          <Grid item xs={6} sx={{ mb: 2 }}>
            <TextField
              id={`mainPrizeTitle${props.lang}`}
              label=" Main Prize Title"
              fullWidth
              value={props.state[`mainPrizeTitle${props.lang}`]}
              variant="standard"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>
          <Grid item xs={6} sx={{ mb: 2 }}>
            <TextField
              id={`secondaryPrizeTitle${props.lang}`}
              label=" Secondary Prize Title"
              fullWidth
              value={props.state[`secondaryPrizeTitle${props.lang}`]}
              variant="standard"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>
          <Grid item xs={6} sx={{ mb: 2 }}>
            <TextField
              id={`mainPrizeDesc${props.lang}`}
              label=" Main Prize Desc"
              fullWidth
              value={props.state[`mainPrizeDesc${props.lang}`]}
              variant="standard"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>
          <Grid item xs={6} sx={{ mb: 2 }}>
            <TextField
              id={`secondaryPrizeDesc${props.lang}`}
              label=" Secondary Prize Desc"
              fullWidth
              value={props.state[`secondaryPrizeDesc${props.lang}`]}
              variant="standard"
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>

          <Grid item xs={12} sx={{ mb: 2 }}>
            <TextField
              id={`prizeText${props.lang}`}
              label="Prize Text"
              fullWidth
              value={props.state[`prizeText${props.lang}`]}
              multiline
              rows={4}
              onChange={(e) => props.handleChange(e)}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="h6" gutterBottom>
              Gamezone Image
            </Typography>
            <Box>
              <FormLabel id="card-format-label">Gamezone Image</FormLabel>
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(event) =>
                    props.uploadFiles(event, `gamezoneImage${props.lang}`)
                  }
                />
                <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
              </IconButton>
            </Box>
            {props.state[`gamezoneImage${props.lang}`] ? (
              <img
                style={{
                  margin: "0 auto",
                  width: 100,
                  background: "grey",
                }}
                alt=""
                src={props.state[`gamezoneImage${props.lang}`]}
              />
            ) : (
              <></>
            )}
          </Grid>

          <Grid item xs={6}>
            <Typography variant="h6" gutterBottom>
              Tile Image
            </Typography>
            <Box>
              <FormLabel id="card-format-label">Tile Image</FormLabel>
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(event) =>
                    props.uploadFiles(event, `tileImage${props.lang}`)
                  }
                />
                <Iconify icon={"eva:upload-outline"} sx={{ mr: 2 }} />
              </IconButton>
              {props.state[`tileImage${props.lang}`] ? (
                <img
                  style={{
                    margin: "0 auto",
                    width: 100,
                    background: "grey",
                  }}
                  alt=""
                  src={props.state[`tileImage${props.lang}`]}
                />
              ) : (
                <></>
              )}
            </Box>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
